// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import styled from 'styled-components';
import TaskCompleteIcon from '../../../assets/images/TaskComplete.svg'
import ChallengeCompleteIcon from '../../../assets/images/ChallengeComplete.svg'
import { FormattedMessage } from 'react-intl';
import CongratulationAnimation from './CongratulationAnimation';

const S = {
  Frame: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 84px;
    margin-bottom: 40px;
  `,
  Container: styled.div`
    display: flex;
    width: 663px;
    height: 105px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    background: #FFFFFF;
  `,
  Img: styled.img.attrs<{ isFinalTask: boolean }>((props) => ({ src: IconSwitcher(props.isFinalTask) })) <{ isFinalTask?: boolean }>`
    display: flex;
    margin-left: 35px;
  `,
  Message: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #434343;
    margin-left: 11.88px;
    align-items: center;
    width: 429.12px;
  `,
  ButtonFrame: styled.div`
    display: flex;
    align-items: center;
  `,
  Button: styled.div<{ isFinalTask?: boolean, isDisable?: boolean }>`
  ${props => (props.isDisable) ? 'background: #EFEFEF; cursor: not-allowed;' : 'background: #EF8200; cursor: pointer;'};
    display: flex;
    cursor: pointer;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    height: 43px;
    width: 126px;
  `,
  ButtonText: styled.div<{ isDisable?: boolean }>`
  ${props => (props.isDisable) ? 'color: #C9C9C9;' : 'color: #FFFFFF;'};
    display: flex;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
  `,
  CongratulationAnimation: styled(CongratulationAnimation)`
    position: relative;
    left: 20px;
    top: 10px;
  `
}

const IconSwitcher = (isFinalTask: boolean) => {
  if (isFinalTask) {
    return ChallengeCompleteIcon
  } else {
    return TaskCompleteIcon
  }
}

const MessageSwitcher = (props: any): JSX.Element => {
  if (props.isFinalTask) {
    return (<FormattedMessage id="E043" values={{ br: <br /> }}></FormattedMessage>)
  } else {
    return (<FormattedMessage id="E042" values={{ br: <br /> }}></FormattedMessage>)
  }
}

const ButtonSwitcher = (props: any): JSX.Element => {
  if (props.isFinalTask) {
    return (<FormattedMessage id="E048"></FormattedMessage>)
  } else {
    return (<FormattedMessage id="E047"></FormattedMessage>)
  }
}

const GoNextTask = (props: any): JSX.Element => {
  const isFinalTask = props.isFinalTask;
  const setNavigationClickToRender = props.setNavigationClickToRender;
  const setNavigationFocus = props.setNavigationFocus;
  const nextTaskIndex = props.nextTaskIndex;
  const navigationList = localStorage.getItem('navigationList');
  const handleEndChallenge = props.handleEndChallenge;
  const [isShowCongratulation, setShowCongratulation] = useState(false);
  const [isDisable, setDisable] = useState(false);

  const handleNextTaskOrEnd = () => {
    if (isFinalTask) {
      setShowCongratulation(true);
      setDisable(true);
      handleEndChallenge();
      return;
    }
    if (navigationList) {
      const mdPath = `${JSON.parse(navigationList)[nextTaskIndex].path}/README.md`;
      setNavigationClickToRender(mdPath);
      localStorage.setItem('mdPath', mdPath);
      setNavigationFocus(JSON.parse(navigationList)[nextTaskIndex].title);
      localStorage.setItem('lastFocus', JSON.parse(navigationList)[nextTaskIndex].title);
    }
  }

  const handleCongratulationEnd = () => {
    setShowCongratulation(false);
  }

  return (
    <S.Frame>
      <S.Container>
        <S.Img isFinalTask={isFinalTask}></S.Img>
        <S.Message>
          <MessageSwitcher isFinalTask={isFinalTask}></MessageSwitcher>
        </S.Message>
        <S.ButtonFrame>
          {isShowCongratulation && <S.CongratulationAnimation onEnd={handleCongratulationEnd} />}
          <S.Button isFinalTask={isFinalTask} isDisable={isDisable} onClick={() => handleNextTaskOrEnd()}>
            <S.ButtonText isDisable={isDisable}>
              <ButtonSwitcher isFinalTask={isFinalTask}></ButtonSwitcher>
            </S.ButtonText>
          </S.Button>
        </S.ButtonFrame>
      </S.Container>
    </S.Frame>
  )
}

export default GoNextTask;
